import {useEffect} from 'react';
import {AppState, View} from 'react-native';
import {useTheme} from './Hooks';
import Providers from './Providers';
import Router from './Router';
import {flushTelemetry, installTelemetryHandlers} from './Utils/Telemetry';
import {ThemedStyleSheet} from './Utils/ThemedStyleSheet';

// The structural-entropy / DISC-5 engine runs entirely in JS/TS from bundled,
// DTA-clean assets (src/Models + src/Engine) — there is no on-device MoDN model
// to load, so the app renders immediately with no ONNX runtime dependency.
function App() {
  return (
    <Providers>
      <AppContent />
    </Providers>
  );
}

const AppContent: React.FC = () => {
  const theme = useTheme();
  const styles = getStyles(theme);

  // Research data sharing (off unless a site enabled it): report crashes and
  // drain the local queue when the app starts or returns to the foreground.
  useEffect(() => {
    installTelemetryHandlers();
    flushTelemetry().catch(() => undefined);
    const subscription = AppState.addEventListener('change', (state) => {
      if (state === 'active') {
        flushTelemetry().catch(() => undefined);
      }
    });
    return () => subscription?.remove?.();
  }, []);

  return (
    <View style={styles.container}>
      <Router />
    </View>
  );
};

const getStyles = ThemedStyleSheet((theme) => ({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background,
  },
}));

export default App;
